import { Input } from "antd";
import styles from "../../../styles/shared/create-bot/CreateBotSettings.module.css";

function BotNameSettings({ name, changeConfig, className = "" }) {
  return (
    <>
      <div className={`${styles.inputWrapper} ${className}`}>
        <span className={styles.inputLabel}>Bot Name</span>
        <Input
          placehodler="Enter Bot Name"
          value={name}
          onChange={(e) => {
            const name = e.target.value?.replace(/^\s+/, "");
            changeConfig("bot_name", name);
          }}
          // style={{ width: "150px" }}
        />
      </div>
      {/*<div className={styles.stepTitle}>*/}
      {/*  <h6>*/}
      {/*    <FaCaretRight /> Name of your CryptoCrispy Bot*/}
      {/*  </h6>*/}
      {/*</div>*/}
    </>
  );
}

export default BotNameSettings;
